import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { useTable, usePagination, useSortBy } from "react-table";
import { Button, Tooltip, Box } from "@mui/material";
import { Link, useParams, useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { getCandidates, unSetCandidate, getAssignCandidatesCount } from "./ApiCalls";
import AddIcon from "@mui/icons-material/Add";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Cookies from "js-cookie";
import "../reacttable.css";
import { useQueryClient, useQuery } from "react-query";
import dayjs from "dayjs";
import { isSameDay, subDays } from "date-fns";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import ReactWhatsapp from "react-whatsapp";
import Modal from "@mui/material/Modal";
import { API_URL } from "../../../DesktopApp";
import "./AssignCandidates.css";

function Table({
  columns,
  data,
  fetchData,
  loading,
  pageCount: controlledPageCount,
}) {
  const today_date = dayjs().format("YYYY-MM-DD");
  const yesterday = dayjs(subDays(new Date(), 1)).format("YYYY-MM-DD");
  const [controlledPageIndex, setControlledPage] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [candidateId, setCandidateId] = React.useState([]);

  // const lastlocation = useParams();
  const [reload, setReload] = React.useState(false);
  // scroll to column
  const tableRef = React.useRef();
  //

  // check all
  const [isCheckAll, setIsCheckAll] = React.useState(false);
  const [list, setList] = React.useState([]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    rows,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex:
          localStorage.getItem("tablePageIndex") !== "null"
            ? Number(localStorage.getItem("tablePageIndex"))
            : controlledPageIndex,
        pageSize: 30,
      },
      manualPagination: true,
      autoResetPage: false,
      pageCount: controlledPageCount,
    },
    useSortBy,
    usePagination
  );
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "600px",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 0,
  };

  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  // scroll to column
  const scrollToColumn = (columnIndex) => {
    if (tableRef.current == null) {
      // console.log('');
    } else {
      const headerElement = tableRef.current.querySelector(
        `th:nth-child(${columnIndex + 1})`
      );
      if (headerElement) {
        headerElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }
    }
  };
  //

  React.useEffect(() => {
    fetchData({ pageIndex, pageSize });
  }, [fetchData, pageIndex, pageSize]);

  React.useEffect(() => {
    if (page.length !== 0) {
      setList(page);
    }
    if (rows.length !== 0) {
      setTimeout(() => {
        scrollToColumn(3);
      }, 300);
    }
  }, [rows, page]);

  const handleClickOpen = (lid) => {
    setOpen(true);
    setCandidateId(lid);
  };
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
  };

  // const handleRemove = (valueToRemove) => {
  //   const index = candidateId.indexOf(valueToRemove);
  //   if (index !== -1) {
  //     const newArray = candidateId.slice(0, index).concat(candidateId.slice(index + 1));
  //     setCandidateId(newArray);
  //   }
  // };

  const deleteCandidate = async (lids) => {
    unSetCandidate(lids)
      .then((response) => {
        if (response.data === "candidate deleted") {
          handleClose();
          // alert("Leads Deleted Successfully");
          navigate("/all-candidate");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const next = () => {
    nextPage();
    setControlledPage(pageIndex);
    localStorage.setItem("tablePageIndex", Math.ceil(pageIndex + 1));
  };

  const prev = () => {
    previousPage();
    setControlledPage(pageIndex);
    localStorage.setItem("tablePageIndex", Math.ceil(pageIndex - 1));
  };

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setCandidateId(list.map((id) => id.original.c_id));
    if (isCheckAll) {
      setCandidateId([]);
    }
  };
  const handleSelect = (e) => {
    const { value, checked } = e.target;
    setCandidateId([...candidateId, parseInt(value)]);
    if (!checked) {
      setCandidateId(candidateId.filter((item) => item !== parseInt(value)));
    }
  };

  return (
    <>
      {Cookies.get("role") === "HR Head" ? (
        <Breadcrumb
          PageName="Assign Candidates"
          BackButton={[
            Cookies.get("role") === "HR Head" ? true : false,
            "Add",
            "/add-candidate/assigncandidates",
            <AddIcon />,
          ]}
          // AssignButton={[candidateId.length !== 0 ? true : false, 'Assign Candidates', `/assign-candidates-to/${candidateId}/mypage=${pageIndex}`, <AddIcon />]}
        />
      ) : (
        <Breadcrumb
          PageName="Assign Candidates"
          BackButton={[
            Cookies.get("role") === "HR Head" ? true : false,
            "Add",
            "/add-candidate/assigncandidates",
            <AddIcon />,
          ]}
        />
      )}
      {candidateId.length !== 0 && Cookies.get("role") === "HR Head" ? (
        <Button
          variant="outlined"
          sx={{
            mx: 1,
            justifyContent: "left",
            position: "absolute",
            right: "1rem",
            top: "5.5rem",
            zIndex: 1000,
          }}
          startIcon={<DeleteIcon />}
          onClick={() => handleClickOpen(candidateId)}
        >
          Delete
        </Button>
      ) : (
        ""
      )}

      <div
        className="table"
        ref={tableRef}
        style={{
          marginTop: "0%",
          height: rows.length !== 0 ? "34.6vw" : "auto",
        }}
      >
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                <th>
                  <input
                    type="checkbox"
                    id="selectAll"
                    name="selectAll"
                    onChange={handleSelectAll}
                    checked={isCheckAll}
                  />
                </th>
                <th>Action</th>
                <th>Sr. no</th>
                <th>Candidate CV</th>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={i}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={{ position: "relative" }}
                  >
                    {column.render("Header")}
                    <span
                      style={{
                        color: "#e9e9e9",
                        position: "absolute",
                        top: "1rem",
                        right: "0.3rem",
                      }}
                    >
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FilterAltIcon />
                        ) : (
                          <FilterAltOffIcon />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  key={i}
                  {...row.getRowProps()}
                  style={
                    row.original.c_id === 9 ? { background: "#000000" } : {}
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      name={"checkbox" + i}
                      id={"checkbox" + i}
                      value={row.original.c_id}
                      // onChange={(e)=>{e.target.checked ? setCandidateId(current => [...current, row.original.c_id]) : handleRemove(row.original.c_id)}}
                      onChange={handleSelect}
                      checked={candidateId.includes(row.original.c_id)}
                    />
                  </td>

                  <td>
                    <Tooltip
                      title="Quick Edit"
                      component={Link}
                      to={`/quick-candidate-edit/${row.original.c_id}/mypage=${pageIndex}/assigncandidates`}
                      sx={{ py: 0, px: "5px", borderRadius: "5px" }}
                    >
                      <IconButton>
                        <AutoFixHighIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      title="Edit"
                      component={Link}
                      to={`/edit-candidate/${row.original.c_id}/mypage=${pageIndex}/assigncandidates`}
                      sx={{ py: 0, px: "5px", borderRadius: "5px" }}
                    >
                      <IconButton>
                        <EditIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      title="View"
                      component={Link}
                      to={`/view-candidate/${row.original.c_id}/mypage=${pageIndex}/assigncandidates`}
                      sx={{ py: 0, px: "5px", borderRadius: "5px" }}
                    >
                      <IconButton>
                        <VisibilityIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
            
                    <hr style={{ border: "#ffffff" }} />
                    <Tooltip
                      title="Call"
                      sx={{ py: 0, px: "5px", borderRadius: "5px" }}
                      target="_blank"
                      href={"tel:+" + row.original.c_ccode + row.original.c_mob}
                    >
                      <IconButton>
                        <LocalPhoneIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>

                    <ReactWhatsapp
                      number={"+" + row.original.c_ccode + row.original.c_mob}
                      message="Hello,"
                      style={{
                        outline: "none",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        color: "rgba(0, 0, 0, 0.54)",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      <Tooltip
                        title="Whatsapp"
                        sx={{ py: 0, px: "5px", borderRadius: "5px" }}
                      >
                        <WhatsAppIcon
                          sx={{
                            fontSize: "18px",
                            position: "relative",
                            top: "5px",
                          }}
                        />
                      </Tooltip>
                    </ReactWhatsapp>

                    <Tooltip
                      title="Email"
                      sx={{ py: 0, px: "5px", borderRadius: "5px" }}
                      target="_blank"
                      href={"mailto:" + row.original.c_email}
                    >
                      <IconButton>
                        <MarkunreadIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                  </td>
                  <td>{i}</td>
                  <td>
                    {/* <a style={{textDecoration:"none", textAlign:"center",width:"150px",display: "inherit" , color:"#000"}}
                      href={API_URL + "/uploads/" + row.original.c_pdf}
                      target="_blank"
                    >
                      <DownloadIcon/>
                    </a> */}
                    {row.original.c_pdf !== "" ? (
                      <DownloadIcon onClick={handleOpen1} />
                    ) : null}
                    <Modal
                      open={open1}
                      onClose={handleClose1}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box sx={style}>
                        <iframe
                          height="600px"
                          width="100%"
                          src={API_URL + "/uploads/" + row.original.c_pdf}
                          title="description"
                        ></iframe>
                      </Box>
                    </Modal>
                  </td>

                  {row.cells.map((cell, i) => (
                    <>
                      {/* {cell.column.Header === 'Status' && row.cells[6].value ? 
                      <td key={i} style={{background: '#000000'}} {...cell.getCellProps()}>{cell.render('Cell')}</td> : cell.column.Header === 'Follow Up Date' && row.original.followup === 'Yes' ? <td>{dayjs(row.cells[1].value).format('YYYY-MM-DD') === today_date ? 'Today' : ''}</td> : <td key={i} {...cell.getCellProps()}>{cell.render('Cell')}</td>} */}

                      {cell.column.Header === "Candidate Status" &&
                      row.cells[7].value ? (
                        <td
                          key={i}
                          {...cell.getCellProps()}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Tooltip title={cell.render("Cell")} sx={{ py: 0 }}>
                            <span
                              style={{
                                backgroundColor: row.original.color,
                                padding: "5px 8px",
                                color: "#ffffff",
                              }}
                            >
                              {cell.render("Cell")}
                            </span>
                          </Tooltip>
                        </td>
                      ) : (
                        // :
                        // cell.column.Header === 'Follow Up Date' && row.original.followup === 'Yes'
                        // ?
                        // <td>{dayjs(row.cells[1].value).format('YYYY-MM-DD') === today_date ? 'Today' : ''}</td>
                        <td key={i} {...cell.getCellProps()}>
                          {cell.column.Header === "Date" ? (
                            dayjs(row.cells[0].value).format("YYYY-MM-DD") ===
                            today_date ? (
                              <Tooltip
                                title={
                                  "Today At " +
                                  dayjs(row.cells[0].value).format("hh:mm A")
                                }
                                sx={{ py: 0 }}
                              >
                                <span>
                                  Today at
                                  <br />
                                  {dayjs(row.cells[0].value).format("hh:mm A")}
                                </span>
                              </Tooltip>
                            ) : dayjs(row.cells[0].value).format(
                                "YYYY-MM-DD"
                              ) === yesterday ? (
                              <Tooltip
                                title={
                                  "Yesterday At " +
                                  dayjs(row.cells[0].value).format("hh:mm A")
                                }
                                sx={{ py: 0 }}
                              >
                                <span>
                                  Yesterday at
                                  <br />
                                  {dayjs(row.cells[0].value).format("hh:mm A")}
                                </span>
                              </Tooltip>
                            ) : (
                              <Tooltip
                                title={dayjs(row.cells[0].value).format(
                                  "MMM, DD YYYY - hh:mm A"
                                )}
                                sx={{ py: 0 }}
                              >
                                <span>
                                  {dayjs(row.cells[0].value).format(
                                    "MMM, DD YYYY"
                                  )}
                                  <br />
                                  {dayjs(row.cells[0].value).format("hh:mm A")}
                                </span>
                              </Tooltip>
                            )
                          ) : cell.column.Header === "Follow Up Date" ? (
                            row.cells[8].value !== "0000-00-00 00:00:00" ? (
                              dayjs(row.cells[8].value).format("YYYY-MM-DD") ===
                              today_date ? (
                                <Tooltip
                                  title={
                                    "Today At " +
                                    dayjs(row.cells[8].value).format("hh:mm A")
                                  }
                                  sx={{ py: 0 }}
                                >
                                  <span>
                                    Today at
                                    <br />
                                    {dayjs(row.cells[8].value).format(
                                      "hh:mm A"
                                    )}
                                  </span>
                                </Tooltip>
                              ) : dayjs(row.cells[8].value).format(
                                  "YYYY-MM-DD"
                                ) === yesterday ? (
                                <Tooltip
                                  title={
                                    "Yesterday At " +
                                    dayjs(row.cells[8].value).format("hh:mm A")
                                  }
                                  sx={{ py: 0 }}
                                >
                                  <span>
                                    Yesterday at
                                    <br />
                                    {dayjs(row.cells[8].value).format(
                                      "hh:mm A"
                                    )}
                                  </span>
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title={dayjs(row.cells[8].value).format(
                                    "MMM, DD YYYY - hh:mm A"
                                  )}
                                  sx={{ py: 0 }}
                                >
                                  <span>
                                    {dayjs(row.cells[8].value).format(
                                      "MMM, DD YYYY"
                                    )}
                                    <br />
                                    {dayjs(row.cells[8].value).format(
                                      "hh:mm A"
                                    )}
                                  </span>
                                </Tooltip>
                              )
                            ) : null
                          ) : (
                            <Tooltip title={cell.render("Cell")} sx={{ py: 0 }}>
                              <span>{cell.render("Cell")}</span>
                            </Tooltip>
                          )}
                        </td>
                      )}
                    </>
                  ))}
                </tr>
              );
            })}

            <tr
              style={{
                backgroundColor: "#ffffff",
                position: "sticky",
                bottom: "0",
                zIndex: 1000,
              }}
            >
              {loading ? (
                <td style={{ border: "none" }}>Loading...</td>
              ) : (
                <td style={{ border: "none" }}>
                  Showing {page.length} of {controlledPageCount} results
                </td>
              )}

              <td className="pagination" style={{ border: "none" }}>
                <Button
                  sx={{ p: 0, minWidth: "2rem" }}
                  onClick={() => gotoPage(0)}
                  disabled={!canPreviousPage}
                >
                  {"<<"}
                </Button>{" "}
                <Button
                  sx={{ p: 0, minWidth: "2rem" }}
                  onClick={() => prev()}
                  disabled={!canPreviousPage}
                >
                  {"<"}
                </Button>{" "}
                <span>
                  &nbsp;Page{" "}
                  <strong>
                    {Math.ceil(pageIndex + 1)} of{" "}
                    {Math.ceil(controlledPageCount / pageSize)}
                  </strong>{" "}
                  &nbsp;
                </span>
                <Button
                  sx={{ p: 0, minWidth: "2rem" }}
                  onClick={() => next()}
                  disabled={!canNextPage}
                >
                  {">"}
                </Button>{" "}
                <Button
                  sx={{ p: 0, minWidth: "2rem" }}
                  onClick={() =>
                    gotoPage(Math.ceil(controlledPageCount / pageSize - 1))
                  }
                  disabled={!canNextPage}
                >
                  {">>"}
                </Button>
                {/* <span>
                | Go to page:{' '}
                <input
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={e => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0
                    gotoPage(page)
                  }}
                  style={{ width: '100px' }}
                />
              </span>{' '} */}
                {/* <select
                value={pageSize}
                onChange={e => {
                  setPageSize(Number(e.target.value))
                }}
              >
                {[10, 20, 30, 40, 50].map((pageSize, i) => (
                  <option key={i} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select> */}
                <select
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                  }}
                  style={{ fontSize: "13px", border: "none" }}
                >
                  {[30, 50, 100, 200].map((pageSize, i) => (
                    <option key={i} value={pageSize}>
                      Show {pageSize}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* delete confirm */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete?"}
        </DialogTitle>
        {/* <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText>
        </DialogContent> */}
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={() => deleteCandidate(candidateId)} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function AssignCandidates() {
  const columns = React.useMemo(
    () =>
      Cookies.get("role") === "HR Head"
        ? [
            {
              Header: "Date",
              accessor: "create_dt",
            },
            {
              Header: "Candidate Name",
              accessor: "c_name",
            },
            {
              Header: "Mobile Number",
              accessor: "c_mob",
            },
            {
              Header: "Alt Mobile Number",
              accessor: "c_alt_mob",
            },
            {
              Header: "Email Id",
              accessor: "c_email",
            },
            {
              Header: "Source",
              accessor: "c_source",
            },
            {
              Header: "Position",
              accessor: "c_position",
            },
            {
              Header: "Candidate Status",
              accessor: "c_status",
            },
            {
              Header: "Follow Up Date",
              accessor: "followup_dt",
            },
            {
              Header: "Comments",
              accessor: "comments",
            },
            {
              Header: "City",
              accessor: "city",
            },
            {
              Header: "Locality",
              accessor: "locality",
            },
            {
              Header: "Assigned User",
              accessor: "assign_to",
            },
          ]
        : [
            {
              Header: "Date",
              accessor: "create_dt",
            },
            {
              Header: "Candidate Name",
              accessor: "c_name",
            },
            {
              Header: "Mobile Number",
              accessor: "c_mob",
            },
            {
              Header: "Email Id",
              accessor: "c_email",
            },
            {
              Header: "Source",
              accessor: "c_source",
            },
            {
              Header: "Position",
              accessor: "c_position",
            },
            {
              Header: "Candidate Status",
              accessor: "c_status",
            },
            {
              Header: "Follow Up Date",
              accessor: "followup_dt",
            },
            {
              Header: "Comments",
              accessor: "comments",
            },
            {
              Header: "City",
              accessor: "city",
            },
            {
              Header: "Locality",
              accessor: "locality",
            },
            // {
            //   Header: 'Candidate CV',
            //   accessor: 'c_pdf',
            // },
          ],
    []
  );

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const fetchIdRef = React.useRef(0);
  const queryClient = useQueryClient();
  const [totalcandidatecount, settotalcandidatecount] = React.useState()

  const fetchData = React.useCallback(({ pageSize, pageIndex, data }) => {
    const fetchId = ++fetchIdRef.current;
    // setLoading(true)
    // setTimeout(() => {
    if (fetchId === fetchIdRef.current) {
      const startRow = pageSize * pageIndex;
      // const endRow = startRow + pageSize
      getCandidates(pageSize, Math.ceil(startRow))
        .then((response) => {
          setData(response.data !== "No Data Found" ? response.data : []);
        })
        .catch((err) => {
          console.log(err);
        });

        getAssignCandidatesCount()
        .then((response) => {
            console.log(response)
          settotalcandidatecount(
            response !== "No Data Found" ? response : 0
          );
        })
        .catch((err) => {
          console.log(err);
        });
      setLoading(false);
    }
    // }, 1000)
  }, []);

  const memoizedData = React.useMemo(() => data, [data]);

  return (
    <Table
      columns={columns}
      data={memoizedData}
      fetchData={fetchData}
      loading={loading}
      pageCount={Number(totalcandidatecount)}
    />
  );
}

export default AssignCandidates;
